import { createSelector } from 'reselect';

const domain = (_) => _.currency;

export const getActiveCurrency = createSelector(
    domain, (store) => store.get('activeCurrency')
);
